export function isRepeatedWordTitle(content: string): boolean {
  const tokens = content
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .map((t) => t.replace(/[^a-z0-9]/g, ''))
    .filter(Boolean);
  return tokens.length >= 2 && new Set(tokens).size === 1;
}
